exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SocialButtons-a19a9e5a{margin:0 auto;text-align:center;color:#999}.SocialButtons-a19a9e5a ul{list-style-type:none;margin:0;padding:0}.SocialButtons-a19a9e5a ul li{display:inline-block;margin:0 5px;padding:0}.SocialButtons-a19a9e5a a{transition:all 0.25s ease;display:inline-block}.SocialButtons-a19a9e5a a.fbLink-53d26bfd{color:inherit}.SocialButtons-a19a9e5a a.fbLink-53d26bfd:hover{color:#3b5998}.SocialButtons-a19a9e5a a.twitterLink-54414486{color:inherit}.SocialButtons-a19a9e5a a.twitterLink-54414486:hover{color:#1DA1F2}\n", ""]);

// Exports
exports.locals = {
	"SocialButtons": "SocialButtons-a19a9e5a",
	"fbLink": "fbLink-53d26bfd",
	"twitterLink": "twitterLink-54414486"
};